import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLeaderboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="leaderboard, winner, stats, graph"><path d="M8.25 6.75H15.75V17.25H12H8.25V6.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M1.25 9.25H8.25V17.25H1.25V9.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15.75 10.75H22.75V17.25H15.75V10.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLeaderboard;
